import React, { useState } from 'react';
import PageHero from '../components/common/PageHero';
import { MapPin, Phone, Mail, Clock, Send } from 'lucide-react';
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from 'react-icons/fa';
import { sendWhatsAppMessage } from '../utils/whatsapp';


const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });


  const [isSubmitting, setIsSubmitting] = useState(false);


  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    sendWhatsAppMessage(formData);
    window.setTimeout(() => {
      setIsSubmitting(false);
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
    }, 500);
  };


  const contactInfo = [
    {
      icon: <MapPin size={24} />,
      title: 'Visit Us',
      details: ['Shop no 30, Dimple Arcade,  Thakur Complex,  Kandivali East,  Mumbai 400101']
    },
    {
      icon: <Phone size={24} />,
      title: 'Call Us',
      details: ['+91 9594184195', '+91 8637730449']
    },
    {
      icon: <Mail size={24} />,
      title: 'Email Us',
      details: ['info@infinityenterprises.in']
    },
    {
      icon: <Clock size={24} />,
      title: 'Working Hours',
      details: ['Monday - Friday: 9:00 AM - 6:00 PM', 'Saturday: 9:00 AM - 2:00 PM', 'Sunday: Closed']
    }
  ];

  const socialLinks = [
    { icon: <FaFacebook size={20} />, url: 'https://facebook.com', label: 'Facebook' },
    { icon: <FaTwitter size={20} />, url: 'https://twitter.com', label: 'Twitter' },
    { icon: <FaLinkedin size={20} />, url: 'https://linkedin.com', label: 'LinkedIn' },
    { icon: <FaInstagram size={20} />, url: 'https://instagram.com', label: 'Instagram' }
  ];

  return (
    <div className="bg-white min-h-screen pb-16 md:pb-20">
      <PageHero
        title="Contact Us"
        subtitle="Get in touch for inquiries, support, or any maritime logistics needs."
      />
      <div className="container-custom pt-12 md:pt-14">
        {/* Contact Info Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6 mb-12 md:mb-14">
          {contactInfo.map((info, index) => (
            <div
              key={index}
              className="card-surface bg-lightGray/70 p-6 lg:p-7 text-center border-lightGray"
            >
              <div className="text-teal flex justify-center mb-3">
                {info.icon}
              </div>
              <h3 className="text-lg font-bold text-navy mb-2">
                {info.title}
              </h3>
              {info.details.map((detail, i) => (
                <p key={i} className="text-darkGray/70 text-sm">
                  {detail}
                </p>
              ))}
            </div>
          ))}
        </div>

        {/* Contact Form and Map */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-10">
          {/* Contact Form */}
          <div className="card-surface bg-lightGray/70 p-7 lg:p-8 border-lightGray">
            <h2 className="text-2xl font-bold text-navy mb-3 tracking-tight">Connect with us</h2>
            <p className="text-darkGray/75 text-sm mb-6 leading-relaxed">
              Have a question or need assistance? Fill out the form below and our team will respond on WhatsApp. We typically reply within one business day.
            </p>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-darkGray font-medium mb-2">Full Name *</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal/40 focus:border-teal transition-colors bg-white"
                    placeholder="Enter your name"
                  />
                </div>
                <div>
                  <label className="block text-darkGray font-medium mb-2">Email Address *</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal/40 focus:border-teal transition-colors bg-white"
                    placeholder="Enter your email"
                  />
                </div>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-darkGray font-medium mb-2">Phone Number *</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal/40 focus:border-teal transition-colors bg-white"
                    placeholder="Enter your phone number"
                  />
                </div>
                <div>
                  <label className="block text-darkGray font-medium mb-2">Subject *</label>
                  <input
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal/40 focus:border-teal transition-colors bg-white"
                    placeholder="Enter subject"
                  />
                </div>
              </div>
              
              <div>
                <label className="block text-darkGray font-medium mb-2">Message</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="5"
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal/40 focus:border-teal transition-colors resize-none bg-white"
                  placeholder="Enter your message (optional)"
                ></textarea>
              </div>
              
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-gradient-to-r from-navy to-teal text-white py-3.5 rounded-lg font-semibold hover:opacity-95 transition-opacity flex items-center justify-center gap-2 disabled:opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal"
              >
                {isSubmitting ? 'Opening WhatsApp…' : 'Send via WhatsApp'}
                <Send size={18} aria-hidden />
              </button>
            </form>
          </div>

          {/* Map and Social Media */}
          <div className="space-y-6 lg:space-y-8">
            {/* Google Map */}
            <div className="card-surface overflow-hidden border-lightGray p-0">
              <iframe
                title="Infinity Enterprises Location"
                src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d7535.260615005923!2d72.86364959108654!3d19.211342928436228!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sShop%20no%2030%2C%20Dimple%20Arcade%2C%20%20Thakur%20Complex%2C%20%20Kandivali%20East%2C%20%20Mumbai%20400101!5e0!3m2!1sen!2sin!4v1776076717812!5m2!1sen!2sin"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="w-full"
              ></iframe>
            </div>

            {/* 24/7 Support Banner */}
            <div className="rounded-xl bg-gradient-to-br from-navy to-teal p-6 lg:p-7 text-white text-center shadow-card border border-white/10">
              <h3 className="text-xl font-bold mb-2 tracking-tight">24/7 emergency support</h3>
              <p className="text-white/90 mb-4 text-sm leading-relaxed">For urgent maritime assistance, contact our emergency helpline.</p>
              <div className="flex items-center justify-center gap-2">
                <Phone size={20} />
                <span className="text-xl font-bold">+91 9594184195</span>
              </div>
            </div>

            {/* Social Media Links */}
            <div className="card-surface bg-lightGray/70 p-6 text-center border-lightGray">
              <h3 className="text-lg font-bold text-navy mb-4 tracking-tight">Follow us</h3>
              <div className="flex justify-center gap-4">
                {socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-white hover:bg-teal hover:text-white p-3 rounded-full transition-all duration-300 text-darkGray"
                    aria-label={social.label}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;